import Vue from 'vue'
import VueRouter from 'vue-router'
const Home = () => import('../views/Home.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login')
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    children: [
      {
        path: '/constant-type',
        name: 'ConstantType',
        component: () => import('@/views/constant-type')
      },
      {
        path: '/constant-item',
        name: 'ConstantItem',
        component: () => import('@/views/constant-item')
      },
      {
        path: '/registlevel',
        name: 'Registlevel',
        component: () => import('@/views/registlevel')
      },
      {
        path: '/department',
        name: 'Department',
        component: () => import('@/views/department')
      },
      {
        path: '/role',
        name: 'Role',
        component: () => import('@/views/role')
      },
      {
        path: '/user',
        name: 'User',
        component: () => import('@/views/user')
      },
      {
        path: '/permission',
        name: 'Permission',
        component: () => import('@/views/permission')
      },
      {
        path: '/register',
        name: 'Register',
        component: () => import('@/views/register')
      },
      {
        path: '/return-num',
        component: () => import('@/views/register/return-num')
      },
      {
        path: '/fee',
        component: () => import('@/views/register/fee')
      },
      {
        path: '/refund',
        component: () => import('@/views/register/refund')
      },
      {
        path: '/check-item',
        name: 'CheckItem',
        component: () => import('@/views/check-item')
      },
      {
        path: '/inspect-item',
        name: 'InspectItem',
        component: () => import('@/views/inspect-item')
      },
      {
        path: '/doctor',
        name: 'Doctor',
        component: () => import('@/views/doctor')
      },
      {
        path: '/cases',
        name: 'Cases',
        component: () => import('@/views/doctor/Cases')
      },
      {
        path: '/dept_list',
        name: 'DeptList',
        component: () => import('@/views/doctor/dept_list')
      },
      // ===== 视光业务页面 =====
      { path: '/customer', name: 'Customer', component: () => import('@/views/customer/index') },
      { path: '/customer/detail/:id', name: 'CustomerDetail', component: () => import('@/views/customer/detail') },
      { path: '/appointment', name: 'Appointment', component: () => import('@/views/appointment/index') },
      { path: '/triage', name: 'Triage', component: () => import('@/views/triage/index') },
      { path: '/optometry', name: 'Optometry', component: () => import('@/views/optometry/index') },
      { path: '/vision-function', name: 'VisionFunction', component: () => import('@/views/visionFunction/index') },
      { path: '/lens-fitting', name: 'LensFitting', component: () => import('@/views/lensFitting/index') },
      { path: '/lens-followup', name: 'LensFollowup', component: () => import('@/views/lensFollowup/index') },
      { path: '/prescription', name: 'Prescription', component: () => import('@/views/prescription/index') },
      { path: '/prescription/detail/:id', name: 'PrescriptionDetail', component: () => import('@/views/prescription/detail') },
      { path: '/glasses-order', name: 'GlassesOrder', component: () => import('@/views/glassesOrder/index') },
      { path: '/glasses-order/detail/:id', name: 'GlassesOrderDetail', component: () => import('@/views/glassesOrder/detail') },
      { path: '/work-order', name: 'WorkOrder', component: () => import('@/views/workOrder/index') },
      { path: '/product', name: 'Product', component: () => import('@/views/product/index') },
      { path: '/category', name: 'Category', component: () => import('@/views/category/index') },
      { path: '/supplier', name: 'Supplier', component: () => import('@/views/supplier/index') },
      { path: '/stock', name: 'Stock', component: () => import('@/views/stock/index') },
      { path: '/purchase', name: 'Purchase', component: () => import('@/views/purchase/index') },
      { path: '/stock-in', name: 'StockIn', component: () => import('@/views/stockIn/index') },
      { path: '/stock-out', name: 'StockOut', component: () => import('@/views/stockOut/index') },
      { path: '/stock-check', name: 'StockCheck', component: () => import('@/views/stockCheck/index') },
      { path: '/price-system', name: 'PriceSystem', component: () => import('@/views/priceSystem/index') },
      { path: '/charge', name: 'Charge', component: () => import('@/views/charge/index') },
      { path: '/sg-refund', name: 'SgRefund', component: () => import('@/views/refund/index') },
      { path: '/shift', name: 'Shift', component: () => import('@/views/shift/index') },
      { path: '/invoice', name: 'Invoice', component: () => import('@/views/invoice/index') },
      { path: '/member', name: 'Member', component: () => import('@/views/member/index') },
      { path: '/member/detail/:id', name: 'MemberDetail', component: () => import('@/views/member/detail') },
      { path: '/member-level', name: 'MemberLevel', component: () => import('@/views/memberLevel/index') },
      { path: '/recharge', name: 'Recharge', component: () => import('@/views/recharge/index') },
      { path: '/coupon', name: 'Coupon', component: () => import('@/views/coupon/index') },
      { path: '/member-coupon', name: 'MemberCoupon', component: () => import('@/views/memberCoupon/index') },
      { path: '/member-tag', name: 'MemberTag', component: () => import('@/views/memberTag/index') },
      { path: '/report-daily', name: 'ReportDaily', component: () => import('@/views/report/daily') },
      { path: '/report-visits', name: 'ReportVisits', component: () => import('@/views/report/visits') },
      { path: '/report-inventory', name: 'ReportInventory', component: () => import('@/views/report/inventory') },
      { path: '/report-members', name: 'ReportMembers', component: () => import('@/views/report/members') },
      { path: '/import', name: 'Import', component: () => import('@/views/import') }
    ]
  }
]

const router = new VueRouter({
  routes
})

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // to 将要访问的路径
  // from 代表从哪个路径跳转而来
  // next 是一个函数，表示放行
  //     next()  放行    next('/login')  强制跳转
  if (to.path === '/login') return next()
  // 获取token
  const tokenStr = window.sessionStorage.getItem('token')
  if (!tokenStr) return next('/login')
  next()
})

export default router
